'use strict';

import $ from 'jquery';

$.fn.exists = function() {
  return this.length > 0;
};
